import axios from 'axios';

export function getBankDays(date, country) {
    return axios.get(`/api/bank_days/${country}/${date.format('DD-MM-YYYY')}`);
}
